<template>
  <div>
    <div class="box settings-block">
      <md-card class="settings-block-space">
        <h2 class="match-header">SETTINGS</h2>
        <md-card-content>
          <form @submit.prevent="save('setting')" data-vv-scope="setting">
            <label class="card-header">Email Send Time</label>
            <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
              <div class="md-layout-item md-size-35">
                <md-field>
                  <label class="card-header">Timezone:</label>
                  <md-select v-model="time_zone" name="timezone" v-validate="'required'" placeholder="time_zone">
                    <md-option v-for="(timezone, index) in timeZoneList" :key="timezone.value+index" :value="timezone.value">{{timezone.value}}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="timepickerb-none">
              <vue-timepicker v-validate="'required'" name="Start" :format="startFormat" v-model="start_time" @input="inputHandler"></vue-timepicker>
              <vue-timepicker v-validate="'required'" name="End" :format="endFormat" v-model="end_time" hide-disabled-hours :hour-range="rangeDate"></vue-timepicker>
            </div>
            <div>
              <md-checkbox v-model="mon" class="m-left-5 card-header check-sendgrid">Mon</md-checkbox>
              <md-checkbox v-model="tue" class="m-left-5 card-header check-sendgrid">Tue</md-checkbox>
              <md-checkbox v-model="wed" class="m-left-5 card-header check-sendgrid">Wed</md-checkbox>
              <md-checkbox v-model="thu" class="m-left-5 card-header check-sendgrid">Thu</md-checkbox>
              <md-checkbox v-model="fri" class="m-left-5 card-header check-sendgrid">Fri</md-checkbox>
              <md-checkbox v-model="sat" class="m-left-5 card-header check-sendgrid">Sat</md-checkbox>
              <md-checkbox v-model="sun" class="m-left-5 card-header check-sendgrid">Sun</md-checkbox>
            </div>
            <md-button type="submit" class="md-raised md-round md-accent mt-20 ml-0">{{saveText}}</md-button>
          </form>
        </md-card-content>
      </md-card>
      <md-card class="settings-block-space mt-20">
        <h2 class="match-header">EVENT</h2>
        <md-card-content>
          <form @submit.prevent="saveEvent('event')" data-vv-scope="event">
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.approvalByAdmin" class="m-left-5 card-header check-sendgrid">Approvals by Administrators</md-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.tag" class="m-left-5 card-header check-sendgrid">Add/Remove Tag</md-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.matchedAdviser" class="m-left-5 card-header check-sendgrid">Match new adviser</md-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.sendRequestToAdviser" class="m-left-5 card-header check-sendgrid">Send email to adviser (Send first email)</md-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.noRespondedAdvisor" class="m-left-5 card-header check-sendgrid">Advisors that have not responded</md-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.snoozed" class="m-left-5 card-header check-sendgrid">Snoozed</md-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.decline" class="m-left-5 card-header check-sendgrid">Decline</md-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.thankYou" class="m-left-5 card-header check-sendgrid">Thank You</md-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <md-checkbox v-model="event.closeRequest" class="m-left-5 card-header check-sendgrid">Close request</md-checkbox>
              </div>
            </div>
            <md-button type="submit" class="md-raised md-round md-accent mt-20 ml-0">{{saveEventBtn}}</md-button>
          </form>
        </md-card-content>
      </md-card>
      <md-card class="settings-block-space mt-20">
        <h2 class="match-header">Block Domains</h2>
        <md-card-content>
          <form @submit.prevent="saveBlockDomain('blockDomain')" data-vv-scope="event">
            <div class="row">
              <div class="col-md-12">
                <md-field class="mt--6">
                  <md-textarea name="blockDomains" v-model="blockDomains" placeholder="Enter domains" @input="sanitizeBlockDomains"></md-textarea>
                  <span class="md-helper-text">Multiple domain must be comma(,) separated</span>
                </md-field>
              </div>
            </div>
            <md-button type="submit" class="md-raised md-round md-accent mt-20 ml-0">{{saveDomain}}</md-button>
          </form>
        </md-card-content>
      </md-card>
      <md-card class="settings-block-space mt-20">
        <h2 class="match-header">Block Email Addresses</h2>
        <md-card-content>
          <form @submit.prevent="saveEmailAddress('emailAddress')" data-vv-scope="event">
            <div class="row">
              <div class="col-md-12">
                <md-field class="mt--6">
                  <md-textarea name="blockEmailAddresses" v-model="blockEmailAddresses" placeholder="Enter email address" @input="sanitizeBlockEmails"></md-textarea>
                  <span class="md-helper-text">Multiple email must be comma(,) separated</span>
                </md-field>
              </div>
            </div>
            <md-button type="submit" class="md-raised md-round md-accent mt-20 ml-0">{{saveEmail}}</md-button>
          </form>
        </md-card-content>
      </md-card>
      <md-card class="settings-block-space mt-20">
        <h2 class="match-header">App Version</h2>
        <md-card-content>
          <div class="row">
            <div class="col-md-12">
              <md-field class="mt--6">
                <md-textarea name="appVersion" v-model="appVersion" :readonly="true" placeholder="App Version"></md-textarea>
                <span class="md-helper-text">Application version</span>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card class="settings-block-space mt-20">
        <h2 class="match-header">Process Manager Dashboard</h2>
        <md-card-content>
          <div class="row">
            <div class="col-md-12">
              <md-button @click="redirectToProcessDashboard" class="md-raised md-round md-accent mt-20 ml-0">
                Open Process Manager Dashboard
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <!-- <md-card class="settings-block-space mt-20">
        <h2 class="match-header">Reference - Rank (Member Boost)</h2>
        <md-card-content>
          <form @submit.prevent="saveReferenceRank('memberBoost')" data-vv-scope="event">
            <div class="row">
              <div class="col-md-12">
                <md-field class="mt--6">
                  <md-textarea name="referenceRank" v-model="referenceRank" placeholder="Enter rank"></md-textarea>
                  <span class="md-helper-text">Multiple Rank value must be comma(,) separated</span>
                </md-field>
              </div>
            </div>
            <md-button type="submit" class="md-raised md-round md-accent mt-20 ml-0">{{saveRank}}</md-button>
          </form>
        </md-card-content>
      </md-card> -->
    </div>
  </div>
</template>
<script>
import API from "../services/API";
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import timeZone from '@/assets/js/time_zone.json';
import { sanitizeInput } from '../utils/sanitizer';

export default {
  components: {
    VueTimepicker
  },
  data() {
    return {
      api: new API(),
      fullPage: true,
      saveText: 'Save',
      saveEventBtn: 'Save',
      saveDomain: 'Save',
      saveEmail: 'Save',
      saveRank: 'Save',
      configuration: {},
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      sun: false,
      startFormat: 'HH:mm',
      start_time: {
        HH: '08',
        mm: '00'
      },
      endFormat: 'HH:mm',
      end_time: {
        HH: '18',
        mm: '00'
      },
      rangeDate: [[]],
      timeZoneList: [],
      time_zone: 'Eastern Standard Time',
      event: {},
      blockDomains: '',
      blockEmailAddresses: '',
      referenceRank: '',
      appVersion: '1.0.0'
    };
  },
  watch: {
    $route: "loadData"
  },
  async created() {
    this.loadData();
    this.timeZoneList = this.$lodash.orderBy(timeZone, ['value'], ['asc']);
  },
  methods: {
    loadData: async function() {
      await this.api.get(`generalSetting/getOne`).then(configuration => {
        if (configuration.data.getData) {
          this.configuration = configuration.data.getData;
          this.mon = this.configuration.week.mon;
          this.tue = this.configuration.week.tue;
          this.wed = this.configuration.week.wed;
          this.thu = this.configuration.week.thu;
          this.fri = this.configuration.week.fri;
          this.sat = this.configuration.week.sat;
          this.sun = this.configuration.week.sun;
          this.time_zone = this.configuration.timezone;
          if (this.configuration.blockDomains && this.configuration.blockDomains.length) {
            this.blockDomains = this.configuration.blockDomains.join(', ');
          }
          if (this.configuration.blockEmailAddresses && this.configuration.blockEmailAddresses.length) {
            this.blockEmailAddresses = this.configuration.blockEmailAddresses.join(', ');
          }
          // if (this.configuration.referenceRank && this.configuration.referenceRank.length) {
          //   this.referenceRank = this.configuration.referenceRank.join(', ');
          // }
          if (this.configuration.start_time) {
            this.start_time = this.configuration.start_time;
          }
          if (this.configuration.end_time) {
            this.end_time = this.configuration.end_time;
          }
          if (this.configuration.event) {
            this.event = this.configuration.event;
          }
          if (this.configuration.appVersion) {
            this.appVersion = this.configuration.appVersion;
          }
        }
      })
    },
    save: function(scope) {
      if (this.start_time.HH && this.start_time.mm && this.end_time.HH && this.end_time.mm) {
        let currentDate = this.$moment().tz("America/New_York").format('DD-MM-YYYY').toString();

        let dateString = currentDate + ' ' + this.start_time.HH + ':' + this.start_time.mm;
        let dateTimeParts = dateString.split(' ');
        let timeParts = dateTimeParts[1].split(':');
        let dateParts = dateTimeParts[0].split('-');
        let startDate = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1]);
        let startTimeStamp = startDate.getTime() / 1000;

        let endDateString = currentDate + ' ' + this.end_time.HH + ':' + this.end_time.mm;
        let endDateTimeParts = endDateString.split(' ');
        let endTimeParts = endDateTimeParts[1].split(':');
        let endDateParts = endDateTimeParts[0].split('-');
        let endDate = new Date(endDateParts[2], parseInt(endDateParts[1], 10) - 1, endDateParts[0], endTimeParts[0], endTimeParts[1]);
        let endTimeStamp = endDate.getTime() / 1000;
        if (endTimeStamp > startTimeStamp) {
          this.$validator.validateAll(scope).then(async setting => {
            if (setting) {
              var objData = {
                week: {
                  mon: this.mon,
                  tue: this.tue,
                  wed: this.wed,
                  thu: this.thu,
                  fri: this.fri,
                  sat: this.sat,
                  sun: this.sun
                },
                start_time: this.start_time,
                end_time: this.end_time,
                timezone: this.time_zone
              }
              await this.api.post(`generalSetting/updateSetting`, {objData: objData}).then(responseData => {
                // this.saveText = 'Saved';
              });
            }
          })
        } else {
          this.$toast.error('End time is not greater than Start time');
        }
      } else {
        this.$toast.error('Please select time');
      }
    },
    inputHandler(eventData) {
      var hour = parseInt(eventData.HH) + 1;
      if (hour >= 9) {
        this.rangeDate = [[hour, 23]];
      } else {
        this.rangeDate = [[hour, 23]];
      }
    },
    saveEvent: async function(scope) {
      await this.api.post(`generalSetting/updateSetting`, {event: this.event}).then(responseData => {
        this.saveEventBtn = 'Saved';
      });
    },
    saveBlockDomain: async function(scope) {
      await this.api.post(`generalSetting/updateSetting`, {blockDomains: this.blockDomains}).then(responseData => {
        // this.saveDomain = 'Saved';
      });
    },
    saveEmailAddress: async function(scope) {
      await this.api.post(`generalSetting/updateSetting`, {blockEmailAddresses: this.blockEmailAddresses}).then(responseData => {
        // this.saveEmail = 'Saved';
      });
    },
    sanitizeBlockDomains(value) {
      this.blockDomains = sanitizeInput(value);
    },
    sanitizeBlockEmails(value) {
      this.blockEmailAddresses = sanitizeInput(value);
    },
    redirectToProcessDashboard: function() {
      const token = localStorage.getItem('auth0_token');

      if (!token) {
        this.$toast.error('No authentication token found. Please log in first.');
        return;
      }

      try {
        const encryptedToken = Buffer.from(token, 'utf8').toString('base64');

        // Use environment variable instead of hardcoded URL
        const baseUrl = process.env.VUE_APP_PROCESS_DASHBOARD_URL;
        const processDashboardUrl = `${baseUrl}/?token=${encodeURIComponent(encryptedToken)}`;

        window.open(processDashboardUrl, '_blank');

      } catch (error) {
        console.error('Error redirecting to process dashboard:', error);
        this.$toast.error('Failed to redirect to process dashboard.');
      }
    }
    // saveReferenceRank: async function(scope) {
    //   this.isLoading = true;
    //   await this.api.post(`generalSetting/updateSetting`, {referenceRank: this.referenceRank}).then(responseData => {
    //     this.isLoading = false;
    //   });
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue